const axios = require('axios');

import isLoggedIn from "../../../components/isLoggedIn";
import {FAV_LOCAL, FAV_URL_FEED} from "../consts";

export default async () => {
    const promise = new Promise((resolve, reject) => {
        if (typeof window.fav === 'undefined') {
            if (isLoggedIn()) {
                axios.get(FAV_URL_FEED).then((response) => {
                    window.fav = response.data;
                    resolve(window.fav);
                });
            } else {
                let favItems = [];
                const json = window.localStorage.getItem(FAV_LOCAL);
                if (json) {
                    favItems = JSON.parse(json);
                }
                window.fav = favItems;
                resolve(window.fav);
            }
        } else {
            resolve(window.fav);
        }

    });
    return promise;
}
